import type { MouseEvent } from 'react';
import { Fragment, useState } from 'react';
import { NavLink } from 'react-router-dom';

import { Stack } from '@mui/material';

import { useApp } from '@system/app';

import { HeaderSubMenu } from './headerSubMenu';
import { StyledLink } from './styled';

type HeaderMenuProps = {
  isSidebarCollapsed: boolean;
};

export const HeaderMenu = (props: HeaderMenuProps) => {
  const { isSidebarCollapsed } = props;
  const app = useApp();
  const menu = app.mainMenu.use();

  const [activeMenuPath, setActiveMenuPath] = useState<string | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: MouseEvent<HTMLElement>, path: string) => {
    event.preventDefault();
    if (activeMenuPath === path) {
      setActiveMenuPath(null);
      setAnchorEl(null);
    } else {
      setActiveMenuPath(path);
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setActiveMenuPath(null);
    setAnchorEl(null);
  };

  return (
    <Stack
      flexDirection="row"
      gap={4}
      pl={isSidebarCollapsed ? 7 : 36}
      sx={{
        transition: '0.5s ease',
      }}
    >
      {menu.map((item, index) => (
        <Fragment key={`${index}-${item.path}`}>
          <StyledLink
            to={item.path}
            component={NavLink}
            onClick={
              item.items
                ? (e: MouseEvent<HTMLElement, globalThis.MouseEvent>) => {
                    handleClick(e, item.path);
                  }
                : undefined
            }
            data-testid={item?.dataTestId ?? item.title}
          >
            {item.title}
          </StyledLink>

          {item.items && activeMenuPath === item.path && (
            <HeaderSubMenu
              anchorEl={anchorEl}
              items={item.items}
              onClose={handleClose}
            />
          )}
        </Fragment>
      ))}
    </Stack>
  );
};
